import React, { FunctionComponent } from 'react';
import { Box } from 'rebass/styled-components';
import {
  Heading, Section,
} from '..';
import { MavenApiKey } from '.';

const copyText = require('./copy-text.json');

const { V1_API_KEY_TITLE, V1_API_KEY_SUBTITLE } = copyText;

const DeveloperKeysV1: FunctionComponent<{}> = () => (
  <Box>
    <Heading>API Authorization</Heading>
    <Section
      title={V1_API_KEY_TITLE}
      subtitle={V1_API_KEY_SUBTITLE}
    >
      <MavenApiKey />
    </Section>
  </Box>
);

export default DeveloperKeysV1;
